const pinkPalette = {
  main: '#fdd1ff',
  light: '#fef1ff',
  dark: '#b85cc4'
}

export default pinkPalette;